import { useMPEFetch, useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import {
  PriceControlEventAction,
  PriceControlItemEventsDTO,
  PriceControlItemsEventAction,
  PriceControlValidateDTO,
} from '@retail/price-control/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface FetchProps extends QueryOptions {
  assortmentId: number;
  memberEventId: number;
}

export function useFetchPriceControlItemEvents({
  assortmentId,
  memberEventId,
  ...queryOptions
}: FetchProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PriceControlItemEventsDTO>({
    method: 'GET',
    queryKey: ['price-control-item-events', assortmentId, memberEventId],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceControl.assortment.assortmentId.events.memberEventId.getFullLinkPath({
        assortmentId,
        memberEventId,
      }),
    }),
    ...queryOptions,
  });
}

interface PostProps extends QueryOptions {
  assortmentId: number;
}

export function usePriceControlItemEventAction({ assortmentId, ...queryOptions }: PostProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, PriceControlEventAction[]>({
    method: 'POST',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceControl.assortment.assortmentId.eventActions.getFullLinkPath({
        assortmentId,
      }),
    }),
    token,
    ...queryOptions,
  });
}

interface Props extends PostProps {
  memberEvent: PriceControlItemsEventAction;
}

export function useFetchPriceControlItemsEvents({
  assortmentId,
  memberEvent,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PriceControlValidateDTO[]>({
    method: 'POST',
    queryKey: ['price-control-items-event', assortmentId, memberEvent],
    token,
    body: memberEvent,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceControl.assortment.assortmentId.eventActions.validate.getFullLinkPath({
        assortmentId,
      }),
    }),
    ...queryOptions,
  });
}
